import { render, staticRenderFns } from "./OrderDetailsDialog.vue?vue&type=template&id=6549dd8a&scoped=true"
import script from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
export * from "./OrderDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailsDialog.vue?vue&type=style&index=0&id=6549dd8a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6549dd8a",
  null
  
)

export default component.exports